export const API_ROOT_URL = process.env.REACT_APP_API_URL;
export const API_URL = API_ROOT_URL + '/api';   // Defined in .env

/**
 * Header type names
 * @type {{SESSIONS: string, CALENDAR: string}}
 */
export const tabNames = {
    SESSIONS: 'sessions',
    CALENDAR: 'calendar',
    SETTINGS: 'settings',
    ADMIN: 'admin'
};

/* Calendar static variables */
export const minutesPerSlot = 5;    // amount of time a calendar slot holds
export const slotHeight = 7;        // In pixels
export const slotWidth = 120;       // In pixels
export const minutesPerPaper = 15;  // amount of time allocated for the presentation of a paper
export const defaultSessionDurationMinutes = 60;  // default amount of time allocated for a session

/* Activity types */
export const activityTypes = {
    SAVE: 'Save'
};
